import { Select } from "antd";
import { FC } from "react";

const SelectPublishField: FC<any> = (props: any) => {
  return (
    <Select {...props}  >
      <Select.Option key="true" >منتشر شده</Select.Option>
      <Select.Option key="false"   >عدم انتشار</Select.Option>
    </Select>
  )
}

export default SelectPublishField
